import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css']
})
export class ChartsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

   Highcharts: typeof Highcharts = Highcharts;

  // 1. State-wise Distribution
  stateChartOptions: any = {
    chart: { type: 'pie' },
    title: { text: 'State-wise Distribution' },
    series: [{
      type: 'pie',
      colorByPoint: true,
      data: [
        { name: 'Tamil Nadu', y: 85, color: '#1FA8C9' },
        { name: 'Telangana', y: 72, color: '#666666' },
        { name: 'Karnataka', y: 68, color: '#A38F79' },
        { name: 'Maharashtra', y: 91, color: '#454E7C' },
        { name: 'West Bengal', y: 60, color: '#A868B7' },
        { name: 'New Delhi', y: 55, color: '#FCC700' }
      ]
    }]
  };

  // 2. Device Inventory
  deviceChartOptions: Highcharts.Options = {
    chart: { type: 'column' },
    title: { text: 'Device Inventory' },
    xAxis: { type: 'category' },
    series: [{
      type: 'column',
      data: [
        { name: 'HP Elitebook 840 G8 Laptop', y: 12, color: '#3CCCCB' },
        { name: 'Dell Latitude 5540 Business Laptop', y: 8, color: '#A868B7' },
        { name: 'HP Desktop Workstation 3', y: 15, color: '#A1A6BD' },
        { name: 'Cisco Catalyst 2960-X Switch', y: 6, color: '#5AC189' },
        { name: 'Epson Projector', y: 4, color: '#A38F79' },
        { name: 'HP Laserjet Printer', y: 9, color: '#FEC0A1' }
      ]
    }]
  };

  // 3. Furniture & Office Assets
  furnitureChartOptions: Highcharts.Options = {
    chart: { type: 'bar' },
    title: { text: 'Furniture & Office Assets' },
    xAxis: { type: 'category' },
    series: [{
      type: 'bar',
      data: [
        { name: 'Wooden Office Desk', y: 10, color: '#A868B7' },
        { name: 'Executive Swivel Chair', y: 7, color: '#FF7F44' },
        { name: 'Leather Sofa', y: 3, color: '#E04355' },
        { name: 'Sofa', y: 5, color: '#D1C6BC' },
        { name: 'Desk Control - DC01', y: 2, color: '#FF7F44' }
      ]
    }]
  };

  // 4. Cost-Based Assets
  costChartOptions: Highcharts.Options = {
    chart: { type: 'column' },
    title: { text: 'Asset Cost Comparison' },
    xAxis: { type: 'category' },
    series: [{
      type: 'column',
      data: [
        { name: 'Toyota Innova', y: 2300000, color: '#1FA8C9' },
        { name: 'HP Elitebook', y: 1050000, color: '#5AC189' },
        { name: 'Asus Zenbook', y: 950000, color: '#FF7F44' },
        { name: 'Tata Ace Gold', y: 675000, color: '#666666' },
        { name: 'Teleprompter', y: 501500, color: '#FCC700' },
        { name: 'Dell Server', y: 480000, color: '#A868B7' },
        { name: 'Cisco Router', y: 185000, color: '#8FD3E4' },
        { name: 'HP Workstation', y: 120000, color: '#ACE1C4' }
      ]
    }]
  };

}
